import {Injectable} from '@angular/core';

import {AppService} from './app.service';
import {BehaviorSubject, Observable} from "rxjs";
import { AngularFireMessaging } from '@angular/fire/compat/messaging'
import {SystemService} from "./system.service";
import { NotificacionModel, NotificationUserModel } from '../models/notification.model';
import { ResponseStatusType } from '../enumerators/enumerators.enum';
import { ConfigService } from './app-config.service';

@Injectable()
export class NotificacionesService
{

	private readonly uriApi: string;
	messagingFirebase : any = null;
	tokenFirebase : string = "";

	public urlController :string = "";
	notificationsReceived : any;
	unreadNotifications : number = 0;
	lastNotificationId : number = 0;
	notifications : Array<NotificacionModel> = [];
	notificationsUnread : Array<NotificacionModel> = [];
	notificationsRead : Array<NotificacionModel> = [];
	newNotifications: string = '0';

	public actualizarNotificaciones: BehaviorSubject<Array<NotificacionModel>> = new BehaviorSubject<Array<NotificacionModel>>([]);

	constructor(
		private readonly appService: AppService, 
		private readonly sistemaService : SystemService, 
		private readonly afMessaging: AngularFireMessaging, 
		private readonly configService: ConfigService)
	{
		this.uriApi = this.appService.base64ToString(this.configService.config.extingueServicesUrl);

		// Variables del servicio de notificaciones
		this.unreadNotifications = 0;

		// Suscripción para detectar notificación recibida
		this.notificationsReceived = new Observable(observable =>
		{
			this.messagingFirebase.onMessage((notificacion : any) =>
			{
				if (localStorage.getItem(this.sistemaService.localStoreVariable.JWT))
				{
					this.PlaySonidoNotificacion();
					observable.next(notificacion);
					this.notificaciones().then((respuesta : any) => {});
				}
			});
		});

		// Cargar notificaciones que se recibieron en background
		document.addEventListener("visibilitychange", () =>
		{
			if (document.visibilityState == 'visible' && localStorage.getItem(this.sistemaService.localStoreVariable.AOT)) {
				this.ultimaNotificacion().then((lastNotificationId : any) => {
					if (lastNotificationId > 0 && this.lastNotificationId != lastNotificationId) {
						this.lastNotificationId = lastNotificationId;
						this.notificaciones().then((respuesta : any) => {});
					}
				});
			}
		});
	}

	ngOnInit(): void {
		this.notificaciones().then((respuesta : any) => {});
	}

	public requestPermission() {
		this.afMessaging.requestPermission.subscribe(
		{
			next: (token) => {
				// console.log('Permiso concedido')
			},
			error: (error) => {
				// console.log('Permiso denegado')
			}
		});   
	}

	public listenForMessages() {
		this.afMessaging.messages.subscribe((message) => {
			//console.log('Mensaje recibido:', message);
			// Maneja aquí la notificación recibida
		});
	}

	public getToken(): Promise<string>{
		return new Promise((resolve, reject) => {
			this.afMessaging.requestToken.subscribe({
				next: (token) => {
					resolve(token!);
				},
				error: (error) => {
					reject('');
				}
			});  
		});		
	}

	public receiveNotifications()
	{
		return this.notificationsReceived;
	}

	public UpdateToken()
	{
		this.afMessaging.getToken.subscribe({
			next: (token) => {
				if(token){
					this.afMessaging.deleteToken(token).subscribe({
						next: (token) => {
							this.getToken();
						},
						error: (error) => {}
					});
				} else {
					this.getToken();
				}
			},
			error: (error) => {}
		});
	}

	public PlaySonidoNotificacion()
	{
		let audio = new Audio();
		audio.src = "../../assets/Sonidos/notificacion.mp3";
		audio.load();
		audio.play();
	}

	// Servicios
	public ultimaNotificacion(): Promise<number>
	{
		return new Promise((resolve) =>
		{
			this.appService.get(this.uriApi + `notificationusers/lastNotification/${this.sistemaService.user.id}`).subscribe({
				next: (response) => {
					if (response.status === ResponseStatusType.OK) {
						response = this.appService.decrypt(response.data);
						return resolve(response.identifier);
					} else {
						return resolve(-1);
					}
				},
				error: () => {
					return resolve(-1);
				}
			});
		});
	}

	public notificaciones(): Promise<boolean>
	{
		return new Promise((resolve) =>
		{
			this.appService.get(this.uriApi + `notificationusers/all/${this.sistemaService.user.id}`).subscribe({
				next: (response) => {
					if (response.status === ResponseStatusType.OK) {
						response = this.appService.decrypt(response.data);
						
						let notificationsUser: NotificationUserModel[] = response;
						let notifications: NotificacionModel[] = [];
						notificationsUser.forEach(notification => {
							notifications.push({
								id: notification.id,
								identifier: notification.notification?.identifier,
								notificationTemplateId: notification.notification?.notificationTemplateId,
								title: notification.notification?.title,
								message: notification.notification?.message,
								url: notification.notification?.url,
								readNotification: notification.readNotification,
								viewNotification: notification.viewNotification,
								readDateOn: notification.readDateOn,
								viewDateOn: notification.viewDateOn,
								createdOn: notification.notification?.createdOn,
								dateView: notification.dateView
							});
						});
						this.setNotificaciones(notifications);

						return resolve(true);
					} else {
						return resolve(false);
					}
				},
				error: () => {
					return resolve(false);
				}
			});
		});
	}

	public setNotificaciones(notifications : Array<NotificacionModel>)
	{

		this.notifications = notifications;
		this.actualizarNotificaciones.next(this.notifications);

		this.notificationsUnread = notifications.filter(notification => !notification.readNotification);
		this.notificationsRead = notifications.filter(notification => notification.readNotification);

		this.notifications.forEach(n => {
			if(!n.viewNotification){
				this.unreadNotifications++;
			}
		});

		this.newNotifications = this.unreadNotifications.toString();
	}

	public marcarLeida(notificacion : NotificacionModel)
	{
		if (notificacion.readNotification){
		  	return;
		}

		this.appService.get(this.uriApi + `notificationusers/setRead/${notificacion.id}`).subscribe({
			next: (response) => {
				if (response.status === ResponseStatusType.OK) {
					this.notificaciones();
				}
			},
			error: () => {}
		});
	}

	public marcarVistas()
	{
		if (this.unreadNotifications == 0)
		{
			this.newNotifications = '0';
		  	return;
		}

		let notifications: string[] = [];
		this.notifications.forEach( notification => {
			if(!notification.viewNotification){
				notifications.push(notification.id!);
			}
		});

		this.unreadNotifications = 0;
		this.newNotifications = '0';

		this.appService.put(this.uriApi + `notificationusers/setView`, notifications).subscribe({
			next: (response) => {},
			error: () => {}
		});
		
	}

}
